<div class="ng-bento">
	<bento-toolbar class="bento-toolbar" [items]="toolBarButtons">
	</bento-toolbar>
	<!-- Standard -->
	<bm-tree class="tree-font" [store]="standardStore" showCheckboxes="true" (check)="standardChecked()"
	(select)="standardSelected($event)" (expand)="onItemExpanded()"></bm-tree>

	<bm-tree class="tree-font" [store]="staffStore" showCheckboxes="true" (check)="staffChecked()"
	(select)="staffSelected($event)"
	(expand)="onItemExpanded()"></bm-tree>

	<bm-tree class="tree-font" [store]="firmStore" showCheckboxes="true" (check)="firmChecked()"
	(select)="firmSelected($event)"
	(expand)="onItemExpanded()"></bm-tree>
</div>
